export const FEATURED_CREATORS_INFO = 'FEATURED_CREATORS_INFO';
export const CREATORS_INFO = 'CREATORS_INFO';
export const FEATURED_CREATORS_GET_PENDING = 'FEATURED_CREATORS_GET_PENDING';
export const CREATORS_GET_PENDING = 'CREATORS_GET_PENDING';
export const CREATOR_CREATE_PENDING = 'CREATOR_CREATE_PENDING';
export const CREATOR_UPDATE_PENDING = 'CREATOR_UPDATE_PENDING';
